import { render, staticRenderFns } from "./field-duplicate.vue?vue&type=template&id=c80043ae&scoped=true&"
import script from "./field-duplicate.vue?vue&type=script&lang=js&"
export * from "./field-duplicate.vue?vue&type=script&lang=js&"
import style0 from "./field-duplicate.vue?vue&type=style&index=0&id=c80043ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80043ae",
  null
  
)

export default component.exports